import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ViewChildren, HostListener, ElementRef } from '@angular/core';
import { NgForm, FormControl } from '@angular/forms';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { MatDialogRef, MatDialog, MatSelect, MatInput } from '@angular/material';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { Message } from 'src/app/core/class/message';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from 'src/app/core/services/api.service';
import Utils from 'src/app/core/services/app-utils';
import { TreeModel } from 'src/app/core/models/tree-model';
import { ViewPdfComponent } from 'src/app/shared/components/view-pdf/view-pdf.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-add-document-type',
  templateUrl: './add-document-type.component.html',
  styleUrls: ['./add-document-type.component.scss'],
  providers: [Message]
})
export class AddDocumentTypeComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  documentTypeEnterprise = {
    documentTypeId: '',
    name: '',
    parentId: null,
    serviceTypeId: null,
    description: '',
    code: ''
  };

  parentId = null;
  checkFocus = true;
  serviceTypes: comboBox[] = [];
  parentIds: comboBox[] = [];

  serviceTypesFilterCtrl: FormControl = new FormControl();
  parentIdsFilterCtrl: FormControl = new FormControl();

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredParentIds: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();
  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  @ViewChild('focusInput', { static: false }) focusInput: MatInput;
  @ViewChild('serviceTypesSelect', { static: false }) serviceTypesSelect: MatSelect;
  @ViewChild('parentSelect', { static: false }) parentSelect: MatSelect;
  // data tree for combobox
  dataTree: Array<TreeModel> = [];

  constructor(
    private apiService: ApiService,
    private el: ElementRef,
    private documentTypeService: DocumentTypeService,
    public dialogRef: MatDialogRef<AddDocumentTypeComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    public deviceService: DeviceDetectorService
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.cancel();
    });
  }
  checkEscKey = false;
  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.cancel();
    }
  }
  /**
   *  On change is called when selection value from combobox
   */
  onChange($event: string): void {
    // Select data for model documentTypeEnterprise from list dataTree
    if ($event == null) {
      this.documentTypeEnterprise.documentTypeId = '';
    } else {
      this.dataTree.forEach(data => {
        if (data.children.length > 0) {
          if ($event === data.key && data.parentId == null) {
            this.documentTypeEnterprise.parentId = null;
            this.parentId = null;
            this.documentTypeEnterprise.serviceTypeId = null;
            this.documentTypeEnterprise.code = null;
            this.documentTypeEnterprise.name = data.title;
            this.documentTypeEnterprise.description = data.description;
          } else {
            data.children.forEach(child => {
              if ($event === child.key) {
                this.parentId = child.parentId;
                this.documentTypeEnterprise.parentId = null;
                this.documentTypeEnterprise.code = child.code;
                this.documentTypeEnterprise.name = child.title;
                this.documentTypeEnterprise.serviceTypeId = null;
                this.documentTypeEnterprise.description = child.description;
              }
            });
          }
        } else if (data.children.length == 0 && $event === data.key) {
          this.documentTypeEnterprise.parentId = null;
          this.parentId = null;
          this.documentTypeEnterprise.code = null;
          this.documentTypeEnterprise.serviceTypeId = null;
          this.documentTypeEnterprise.name = data.title;
          this.documentTypeEnterprise.description = data.description;
        }
      });
    }
    // Init combobox -> getParentIds or getServiceTypes
    if (this.parentId != null) {
      this.getParentIds(this.documentTypeEnterprise.code);
      this.parentIdsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.commonService.filterCertificateType(this.parentIds, this.parentIdsFilterCtrl, this.filteredParentIds);
      });
    } else {
      this.getServiceTypes($event);
      this.serviceTypesFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
      });
    }
    this.notificationService.subscribeErrorService();
  }

  /**
   * On Init
   */
  ngOnInit() {
    this.apiService.addUrlToHandlingErrorRestApis('/enterprise/document-type');
    this.documentTypeService.getDocumentsType().subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      // Convert Json data to Array<TreeModel>
      for (const node of rs.data) {
        if (node.parentId === undefined) {
          const parentModel = new TreeModel();
          parentModel.title = node.name;
          parentModel.key = node.id;
          parentModel.description = node.description;
          if (!node.hasChildren) {
            parentModel.isLeaf = true;
          }
          this.dataTree.push(parentModel);
        }
      }
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.dataTree.length; i++) {
        for (const child of rs.data) {
          if (child.parentId !== undefined && this.dataTree[i].key === child.parentId) {
            const childModel = new TreeModel();
            childModel.title = child.name;
            childModel.key = child.id;
            childModel.isLeaf = true;
            childModel.parentId = child.parentId;
            childModel.code = child.code;
            childModel.description = child.description;
            this.dataTree[i].children.push(childModel);
          }
        }
      }
    });
  }

  /**
   * On After Init
   */
  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.apiService.removeUrlToHandlingErrorRestApis();
    this.formChangesSubscription.unsubscribe();
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get ServiceType list to show for combobox
   */
  getServiceTypes(id: string) {
    this.documentTypeService.getServiceTypes(id).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      const result = rs.data;
      this.serviceTypes = result;
      this.filteredServiceTypes.next(this.serviceTypes.slice());
    });
  }

  private onUpdateEnterpriseError(rs: any) {
    if (!rs.success) {
      if (rs.code == '0x00125') {
        this.certificateNoExistingHanlder(rs);
      } else {
        this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
      }
    }
  }
  private certificateNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.name.setErrors({ incorrect: true, duplicate: true });
    document.getElementById("name").focus();
  }
  /**
   * Get ParentId list to show for combobox
   */
  getParentIds(code: string) {
    this.documentTypeService.getParentIds(code).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      const result = rs.data;
      this.parentIds = result;
      this.filteredParentIds.next(this.parentIds.slice());
    });
  }

  /**
   * Create document type
   */
  addDocumentType() {
    this.documentTypeService.addDocumentType(this.documentTypeEnterprise, () => { }, () =>
      this.onUpdateEnterpriseError.bind(this))
      .subscribe(rs => {
        if (rs && rs.success) {
          this.toastr.success(this.message.getMessage('messages.add_success'));
          this.router.navigate(['/home-enterprise/document-type']);
          this.dialogRef.close();
        } else if (rs && !rs.success) {
          if (rs.code == '0x00125') {
            this.certificateNoExistingHanlder(rs);
          } else {
            this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
          }
        }
      });
  }
  /**
   * call api view file pdf
   */
  viewHtml(id) {
    this.checkEscKey = true;
    const dialogRe = this.dialog.open(ViewPdfComponent, {
      width: this.deviceService.isMobile() ? '100%' : '1000px',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: { id, isSystem: true },
    });
    dialogRe.afterClosed().subscribe(() => {
      dialogRe.close();
      this.checkEscKey = false;
    });
  }

  /**
   * Close pop-up
   */
  cancel() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }
}
